








































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormEditarDSTStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};

  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfGeneralStreamax'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    console.log(this.data);
    this.formFields.enable.check =
      this.data['?column?'].DST.SW == '0' ? false : true;
    const off =
      parseInt(this.data['?column?'].DST.SH) +
      parseInt(this.data['?column?'].DST.SM);
    const on =
      parseInt(this.data['?column?'].DST.EH) +
      parseInt(this.data['?column?'].DST.EM);
    this.formFields.offset.value = parseInt(this.data['?column?'].switch);
    this.formFields.startTimeMonth.value = this.data['?column?'].DST.SMON;
    this.formFields.starttime.value = this.data['?column?'].DST.SWEEK;
    this.formFields.startdayofweek.value = this.data['?column?'].DST.SWIND;
    this.formFields.startday.value = moment(on, 'HHmm');
    this.formFields.endday.value = moment(off, 'HHmm');
    this.formFields.endtime.value = this.data['?column?'].DST.EWEEK;
    this.formFields.enddayofweek.value = this.data['?column?'].DST.EWIND;
    this.formFields.endtimemonth.value = this.data['?column?'].DST.EMON;
  }
  mounted() {
    this.getTime();
  }
  convertirSegundosAHora(segundos: number): string {
    console.log('prueba:' + segundos);
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const horaString = horas.toString().padStart(2, '0');
    const minutosString = minutos.toString().padStart(2, '0');
    return `${horaString}${minutosString}`;
  }
  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
    console.log(this.formFields);
  }
  onSelectionChanged(params: any) {}
  formFields: {
    enable: any;
    offset: any;
    mode: any;
    starttime: any;
    startday: any;
    startTimeMonth: any;
    startdayofweek: any;
    endtime: any;
    endday: any;
    endtimemonth: any;
    enddayofweek: any;
  } = {
    enable: {
      label: 'Enable',
      check: true,
    },
    offset: {
      label: 'Offset',
      value: 0,
      items: [{ label: 'One Hour', id: 1 }],
    },
    mode: {
      label: 'Mode',
      value: 0,
      items: [{ label: 'Week', id: 0 }],
    },
    startTimeMonth: {
      label: 'Start',
      value: 0,
      items: [
        { label: 'Jan', id: 0 },
        { label: 'Feb', id: 1 },
        { label: 'Mar', id: 2 },
        { label: 'Apr', id: 3 },
        { label: 'May', id: 4 },
        { label: 'Jun', id: 5 },
        { label: 'Jul', id: 6 },
        { label: 'Aug', id: 7 },
        { label: 'Sep', id: 8 },
        { label: 'Oct', id: 9 },
        { label: 'Nov', id: 10 },
        { label: 'Dec', id: 11 },
      ],
    },
    startday: {
      label: '',
      value: moment('00:00', 'HHmm'),
      selectedValue: '17:05:26',
    },
    starttime: {
      label: '',
      value: 0,
      items: [
        { label: '1ST', id: 0 },
        { label: '2ND', id: 1 },
        { label: '3RD', id: 2 },
        { label: '4TH', id: 3 },
        { label: 'LAST', id: 4 },
      ],
    },
    startdayofweek: {
      label: '',
      value: 0,
      items: [
        { label: 'Sunday', id: 0 },
        { label: 'Monday', id: 1 },
        { label: 'Tuesday', id: 2 },
        { label: 'Wednesday', id: 3 },
        { label: 'Thursday', id: 4 },
        { label: 'Fryday', id: 5 },
        { label: 'Saturday', id: 6 },
      ],
    },
    endtimemonth: {
      label: 'End',
      value: 8,
      items: [
        { label: 'Jan', id: 0 },
        { label: 'Feb', id: 1 },
        { label: 'Mar', id: 2 },
        { label: 'Apr', id: 3 },
        { label: 'May', id: 4 },
        { label: 'Jun', id: 5 },
        { label: 'Jul', id: 6 },
        { label: 'Aug', id: 7 },
        { label: 'Sep', id: 8 },
        { label: 'Oct', id: 9 },
        { label: 'Nov', id: 10 },
        { label: 'Dec', id: 11 },
      ],
    },
    endday: {
      label: '',
      value: moment('00:00', 'HHmm'),
      selectedValue: '17:05:26',
    },
    endtime: {
      label: '',
      value: 0,
      items: [
        { label: '1ST', id: 0 },
        { label: '2ND', id: 1 },
        { label: '3RD', id: 2 },
        { label: '4TH', id: 3 },
        { label: 'LAST', id: 4 },
      ],
    },
    enddayofweek: {
      label: '',
      value: 0,
      items: [
        { label: 'Sunday', id: 0 },
        { label: 'Monday', id: 1 },
        { label: 'Tuesday', id: 2 },
        { label: 'Wednesday', id: 3 },
        { label: 'Thursday', id: 4 },
        { label: 'Fryday', id: 5 },
        { label: 'Saturday', id: 6 },
      ],
    },
  };
  selectedEndDayWeek() {
    return this.formFields.enddayofweek.items.find(
      (item: { id: any }) => item.id === this.formFields.enddayofweek.value
    );
  }
  selectedEndTime() {
    return this.formFields.endtime.items.find(
      (item: { id: any }) => item.id === this.formFields.endtime.value
    );
  }
  selectedEndMonth() {
    return this.formFields.endtimemonth.items.find(
      (item: { id: any }) => item.id === this.formFields.endtimemonth.value
    );
  }
  selectedStartMonth() {
    return this.formFields.startTimeMonth.items.find(
      (item: { id: any }) => item.id === this.formFields.startTimeMonth.value
    );
  }
  selectedStartTime() {
    return this.formFields.starttime.items.find(
      (item: { id: any }) => item.id === this.formFields.starttime.value
    );
  }
  selectedStartDay() {
    return this.formFields.startdayofweek.items.find(
      (item: { id: any }) => item.id === this.formFields.startdayofweek.value
    );
  }
  selectedOffset() {
    return this.formFields.offset.items.find(
      (item: { id: any }) => item.id === this.formFields.offset.value
    );
  }
  selectedMode() {
    return this.formFields.mode.items.find(
      (item: { id: any }) => item.id === this.formFields.mode.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
